import { Component } from "react"
import PropTypes from "prop-types"

import { CognitoIdToken } from "amazon-cognito-identity-js"

import {
  USER_POOL,
  APPLICATION_CLIENT_ID,
  COGNITO_COOKIE_PREFIX,
} from "./constants"

const returnUserPoolId = () => {
  const { cookie } = document
  return cookie.includes(USER_POOL)
    ? cookie.split(`${USER_POOL}=`).pop().split(";").shift()
    : ""
}

const returnApplicationClientId = () => {
  const { cookie } = document
  return cookie.includes(APPLICATION_CLIENT_ID)
    ? cookie.split(`${APPLICATION_CLIENT_ID}=`).pop().split(";").shift()
    : ""
}

class UserManagement extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}
    this.loadAuthenticatedUser = this.loadAuthenticatedUser.bind(this)
    this.checkSession = this.checkSession.bind(this)
  }

  componentDidMount() {
    const {
      makeUnauthGetRequest,
      detailsUrlPath,
      cookies,
      renderApplication,
      history,
    } = this.props

    if (!returnUserPoolId() || !returnApplicationClientId()) {
      makeUnauthGetRequest({
        url: detailsUrlPath,
        onFailure: (error) => {
          console.error(error)
          renderApplication()
          history.push("/error/500")
        },
        onSuccess: ({ cognito_app_client_id, cognito_user_pool_id }) => {
          cookies.set(USER_POOL, cognito_user_pool_id, { path: "/" })
          cookies.set(APPLICATION_CLIENT_ID, cognito_app_client_id, {
            path: "/",
          })
          this.checkSession(this.loadAuthenticatedUser, renderApplication)
        },
      })
    } else this.checkSession(this.loadAuthenticatedUser, renderApplication)
  }

  checkSession(callback, renderApp) {
    const { checkSession, history } = this.props
    checkSession({
      info: {
        cognito_app_client_id: returnApplicationClientId(),
        cognito_user_pool_id: returnUserPoolId(),
      },
      loadAuthenticatedUser: callback,
      renderApplication: renderApp,
      history,
    })
  }

  loadAuthenticatedUser({ userPool, cognitoUser }) {
    const {
      location: { search },
    } = this.props

    const searchObject = {
      ...search
        .slice(1)
        .split("&")
        .filter(Boolean)
        .reduce((acc, curr) => {
          const [key, value] = curr.split(/=(.+)/)
          return { ...acc, [key]: value?.replace(/^.*\/\/[^/]+/, "") }
        }, {}),
      refer: search.slice(1).split("refer=")[1],
    }

    const {
      history,
      refreshSession,
      cookies,
      storeUserPool,
      redirect,
      location,
      renderApplication,
    } = this.props

    const { redirect_uri } = searchObject

    if (!redirect_uri) renderApplication()

    const { pathname, href } = window.location

    const pathAppend =
      pathname === "/"
        ? ""
        : `?refer=${href
            .split("refer=")
            .pop()
            .replace(window.location.origin, "")}`

    const { username } = cognitoUser

    const keyPrefix = `${COGNITO_COOKIE_PREFIX}.${userPool.getClientId()}.${username}`

    const idTokenKey = `${keyPrefix}.idToken`

    const cognitoIdToken = new CognitoIdToken({
      IdToken: cognitoUser.storage.getItem(idTokenKey),
    })

    const {
      payload: { exp },
    } = cognitoIdToken

    if (!exp || exp < Date.now() / 1000) {
      history.push(`/logout${pathAppend}`)
      const loggedOut = true
      storeUserPool(userPool, loggedOut)
      renderApplication()
    } else
      cognitoUser.getSession((err, session) => {
        if (err) {
          console.error(err)
          history.push(`/logout${pathAppend}`)
          userPool.storage.clear()
          const loggedOut = true
          storeUserPool(userPool, loggedOut)
          renderApplication()
          return
        }
        if (session) {
          const { refreshToken } = session
          const { refer } = searchObject
          refreshSession({
            userPool,
            refreshToken,
            cookies,
            history,
            pathAppend,
          })
          redirect({ history, redirect_uri, refer, location, pathAppend })
        } else {
          renderApplication()
          history.push(`/login${pathAppend}`)
        }
      })
  }

  render() {
    return null
  }
}

UserManagement.propTypes = {
  cookies: PropTypes.shape({
    set: PropTypes.func.isRequired,
  }).isRequired,
  refreshSession: PropTypes.func.isRequired,
  storeUserPool: PropTypes.func.isRequired,
  checkSession: PropTypes.func.isRequired,
  detailsUrlPath: PropTypes.string.isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    push: PropTypes.func,
  }).isRequired,
  makeUnauthGetRequest: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  redirect: PropTypes.func.isRequired,
  renderApplication: PropTypes.func.isRequired,
}

UserManagement.defaultProps = {
  makeUnauthGetRequest: () => null,
}

export default UserManagement
